import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import MaterialTable from '@material-table/core';

import { TABLE_OPTIONS } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import tableColumns from './tableColumns';

export function HistoryTable({ history, isLoading }) {
  const { localization } = useTableLocalization();
  const tableDefaultColumns = useMemo(() => {
    return tableColumns();
  }, []);

  const options = {
    ...TABLE_OPTIONS.HISTORY
  };

  return (
    <MaterialTable
      columns={tableDefaultColumns}
      data={history}
      options={options}
      localization={localization}
      isLoading={isLoading}
    />
  );
}

const mapStatesToProps = ({ showHistory, loader }) => {
  return {
    ...showHistory,
    isLoading: loader.isSpinVisible
  };
};

export default connect(mapStatesToProps)(HistoryTable);
